import { CUSTOM_ICONS } from './custom';
import { MUI_ICONS } from './entries/mui';
import { SYMBOL_ICONS } from './entries/symbols';

type SharedKeys<A, B> = Record<Extract<keyof A, keyof B>, never>;

// A key present in two sources would be silently overwritten by the spread;
// such a key is typed `never` here, so the merged value fails `satisfies`.
export const ICON_COMPONENTS = {
  ...MUI_ICONS,
  ...SYMBOL_ICONS,
  ...CUSTOM_ICONS,
} satisfies SharedKeys<
  typeof MUI_ICONS,
  typeof SYMBOL_ICONS & typeof CUSTOM_ICONS
> &
  SharedKeys<typeof SYMBOL_ICONS, typeof CUSTOM_ICONS>;

export type IconMetaphor = keyof typeof ICON_COMPONENTS;

export const ICON_METAPHORS = Object.keys(
  ICON_COMPONENTS,
).sort() as IconMetaphor[];

export type IconSource = 'mui' | 'symbol' | 'custom';

export function getIconSource(metaphor: IconMetaphor): IconSource {
  if (metaphor in CUSTOM_ICONS) {
    return 'custom';
  }

  return metaphor in SYMBOL_ICONS ? 'symbol' : 'mui';
}
